import React, { Component } from 'react';
import * as Actions from '../../../../store/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import validate from 'validate.js';
import _ from 'lodash';

const pattern = { invoice: /(SFO|DTR)\d{4}-\d{5}/, phoneNumber: /\d{10}/ };

const validateValues = {
    invoice: {
        presence: { allowEmpty: false, message: 'is required' },
        format: pattern.invoice
    },
    phoneNumber: {
        presence: { allowEmpty: false, message: 'is required' },
        numericality: { onlyInteger: true },
        format: pattern.phoneNumber
    }
};

export class FormCheckStatusOrder extends Component {

    constructor(props) {
        super(props)
    
        this.state = {
            values: {
                invoice: props.invoice || "",
                phoneNumber: ""
            },
            errors: {
                status: false,
                message: {}
            },
            touched: []
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if (!_.isEqual(prevState.values, this.state.values)) {
            const { values } = this.state;

            const errors = validate(values, validateValues);

            let _inValid = errors ? true : false;

            this.setState({
                errors: {
                    status: _inValid,
                    message: errors || {}
                }
            });
        }
    }

    handleChangeData = (e) => {
        e.persist();
        const { name, value } = e.target;
        this.setState({ 
            values: { 
                ...this.state.values, 
                [name]: value 
            },
            touched: [ ...this.state.touched, name ]
        });
    }

    hasError = (field) => {
        const { errors, touched } = this.state;
        return errors.message.hasOwnProperty(field) && touched.includes(field);
    }
    
    render() {
        const { values, errors } = this.state;
        const { wording, GetPurchaseOrderOfGuestByInvoice } = this.props;

        return (
            <div className="flex justify-content-center horizontal-center">
                <div className="form-guest m-90">
                    <div className="form-guest-header">
                        <h4>{ wording.usermenu.purchase.formCheckStatusOrder.title}</h4>
                    </div>
                    <div className="form-guest-body pl-10">
                    
                        <div className="input-boder-bottom mt-10">
                            <i className="fas fa-file-invoice font-size-20 mr-10"></i>
                            <input maxLength={13} type="text" name="invoice" className="w-75 text-white" id="input-invoice" value={values.invoice} onChange={(e) => this.handleChangeData(e)} />
                            <label htmlFor="input-invoice" className="text-white">{ wording.usermenu.purchase.formCheckStatusOrder.invoice }</label>
                            { this.hasError("invoice") && <div className='error ml-10'>* {errors.message.invoice.join(", ")}</div> }
                        </div>

                        <div className="input-boder-bottom mt-10">
                            <i className="fas fa-phone-alt font-size-20 mr-10"></i>
                            <input maxLength={10} type="text" name="phoneNumber" className="w-75 text-white" id="input-telephone" value={values.phoneNumber} onChange={(e) => this.handleChangeData(e)} />
                            <label htmlFor="input-telephone" className="text-white">{ wording.usermenu.purchase.formCheckStatusOrder.phoneNumber }</label>
                            { this.hasError("phoneNumber") && <div className='error ml-10'>* {errors.message.phoneNumber.join(", ")}</div> }
                        </div>

                        <div className="text-center">
                            <button
                                className='btn btn-md btn-dark'
                                disabled={errors.status}
                                onClick={async () => {
                                    GetPurchaseOrderOfGuestByInvoice(values);
                                }}>
                                {wording.usermenu.purchase.formCheckStatusOrder.ok}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = ({ language }) => ({
    wording: language.wording,
});

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators(
      {
        GetPurchaseOrderOfGuestByInvoice: Actions.UserGetPurchaseOrderOfGuestByInvoice
      },
      dispatch
    );
  };

export default connect(mapStateToProps, mapDispatchToProps)(FormCheckStatusOrder);
